import React, { FC } from 'react'
import { Row } from '../../../../legacy-design-system/form'
import { ServerlessAccountsField } from './serverless-accounts-field'
import { ProjectFields } from './project-fields'
import { DefaultPriority } from './default-priority'
import { AdditionalJiraFieldsList } from './additional-jira-fields/additional-jira-fields-list'
import { BugtrackerConfig } from '../api/shared'
import { ServerlessResultsField } from './serverless-results-field'
import { css } from '@emotion/css'

export const ServerlessFields: FC<{ bugtracker?: BugtrackerConfig }> = ({
  bugtracker
}) => {
  return (
    <>
      <Row>
        <ServerlessAccountsField />
      </Row>
      <ProjectFields bugtracker={bugtracker} />
      <Row
        className={css`
          align-items: flex-start;
        `}
      >
        <ServerlessResultsField />
        <DefaultPriority />
        <AdditionalJiraFieldsList bugtracker={bugtracker} />
      </Row>
    </>
  )
}
